import { useAuthStore } from '../store/authStore'

/**
 * Acceso a la sesión actual.
 *
 * Se expone como hook en vez de que las pantallas usen `useAuthStore`
 * directamente. Así, si mañana cambiamos Zustand por otra cosa, solo se toca
 * este archivo — ninguna pantalla se entera.
 *
 * @example
 * const { user, isAuthenticated, signOut } = useAuth()
 */
export function useAuth() {
  const user = useAuthStore((state) => state.user)
  const isLoading = useAuthStore((state) => state.isLoading)
  const signIn = useAuthStore((state) => state.signIn)
  const signOut = useAuthStore((state) => state.signOut)
  const markRequiredPasswordChanged = useAuthStore((state) => state.markRequiredPasswordChanged)

  return {
    user,
    isLoading,
    isAuthenticated: user !== null,
    signIn,
    signOut,
    markRequiredPasswordChanged,
  }
}
